// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  ACESSO_SISTEMA_VALIDAR_ACESSO_TOKEN,
} from './constants';

export function validarAcessoToken(data) {
  return {
    type: ACESSO_SISTEMA_VALIDAR_ACESSO_TOKEN,
    data: data
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ACESSO_SISTEMA_VALIDAR_ACESSO_TOKEN:
      return {
        ...state,
         usuario: action.data.pessoa,
        accessTokens: action.data.usuario,
        loginPending: false,
        loginError: null
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/acesso-sistema/redux/validarAcessoToken.js